import * as React from 'react';

import { observer } from 'mobx-react';

import { classes } from '~utils/Classes';

export interface ITitleProps {
    inputLabel: string;
    htmlTag?: string; // Parent HTML tag
    isChildText?: boolean; // True if add a child div inside parent htmlTag
}

const className = classes('iam-title');
const textClassName = classes('iam-title-text');

export const Title = observer((props: ITitleProps) => {
    const { inputLabel, htmlTag = 'h3', isChildText = true } = props;

    return React.createElement(
        htmlTag,
        { className },
        isChildText
            ? React.createElement('div', { className: textClassName }, inputLabel)
            : inputLabel
    );
});
